export default __webpack_public_path__ + "static/media/tomato-medley-tasting-plate.133ec4fb.jpg";